import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'; 
import { Provider } from 'react-redux';
import { mainStore, persistor } from './app/mainStore';
import { PersistGate } from 'redux-persist/integration/react';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';  
import 'bootstrap-icons/font/bootstrap-icons.css'
import './app/styles/footer.css'
import './app/styles/banner.css'
import './app/styles/milieu.css'
import './app/styles/espacement.css'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>  
    <Provider store={mainStore}>     
      <PersistGate loading={null} persistor={persistor}>
        <App />  
      </PersistGate>     
    </Provider>  
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
